export default __webpack_public_path__ + "static/media/Building Sanitizeration.619b51aa.jpg";